import axios from 'axios'
const Base64 = require('js-base64').Base64

// export const auth = async () => {
//   try {
//     const httpResult = await axios.post(`${process.env.REACT_APP_API_URL}/api/user`)
//     const { data: { data: result } = {} } = httpResult

//     return { data: result }
//   } catch (e) {
//     return { error: e }
//   }
// }

export const checkAuth = async (token) => {
  let api_token = Base64.decode(token)
  axios.defaults.headers.Authorization = `Bearer ${api_token}`
  return axios.post(`${process.env.REACT_APP_API_URL}/api/user`)
}

// export const auth = async ctx => {
//   let { '8egma2jfs9mu': token = '' } = nextCookie(ctx)
//   let api_token = Base64.decode(token)
//   try {
//     axios.defaults.headers['Authorization'] = `Bearer ${api_token}`
//     const result = await axios.post(`${process.env.REACT_APP_API_URL}/api/user`)
//     return result.data.data.api_token
//   } catch (e) {
//     // ctx.res.writeHead(302, {
//     //   Location: process.env.REACT_APP_URL
//     // })
//     // ctx.res.end()
//     return undefined
//   }
// }

// export const withAuthSync = WrappedComponent => {
//   const Wrapper = props => <WrappedComponent {...props} />

//   Wrapper.getInitialProps = async ctx => {
//     const api_token = await auth(ctx)
//     const componentProps =
//       WrappedComponent.getInitialProps &&
//       (await WrappedComponent.getInitialProps(ctx))
//     return { ...componentProps, api_token }
//   }
//   return Wrapper
// }
